import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { VngSelectOption } from "@vengreso/angular-components";
import { DialogService } from "src/app/core/core-services/services/dialog.service";
import { WarningDialogComponent } from "src/app/core/core-services/warning-dialog/warning-dialog.component";
import { BaseSettingsSectionComponent } from "../base-settings-section.component";
import { ExtensionSettingsService } from "../extension-settings.service";
import { GrammarLanguage } from "../extension-settings.models";

@Component({
    selector: "app-flygrammar-settings",
    templateUrl: "./flygrammar-settings.component.html",
    styleUrls: ["./flygrammar-settings.component.scss"],
    standalone: false
})
export class FlygrammarSettingsComponent extends BaseSettingsSectionComponent implements OnInit, OnChanges {
  @Input() languages: GrammarLanguage[] = [];
  @Input() initialEnabled = true;
  @Input() initialLanguage = "";
  @Input() canDisableFlyGrammar = true;

  private lastSavedEnabled: boolean;
  private lastSavedLanguage: string;

  constructor(
    private readonly fb: FormBuilder,
    private readonly settingsService: ExtensionSettingsService,
    private readonly dialog: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    this.lastSavedEnabled = this.initialEnabled;
    this.lastSavedLanguage = this.initialLanguage;
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialEnabled && !changes.initialEnabled.firstChange) {
      this.lastSavedEnabled = changes.initialEnabled.currentValue;
      if (this.form) {
        this.form.patchValue({ flyGrammar: this.lastSavedEnabled }, { emitEvent: false });
        this.markPristine();
      }
    }
    if (changes.initialLanguage && !changes.initialLanguage.firstChange) {
      this.lastSavedLanguage = changes.initialLanguage.currentValue;
      if (this.form) {
        this.form.patchValue({ flyGrammarLanguage: this.lastSavedLanguage }, { emitEvent: false });
        this.markPristine();
      }
    }
  }

  buildForm(): FormGroup {
    return this.fb.group({
      flyGrammar: [this.initialEnabled],
      flyGrammarLanguage: [this.initialLanguage],
    });
  }

  getSaveObservable(): Observable<any> {
    if (!this.canDisableFlyGrammar) {
      this.dialog.openDialogComponent(
        WarningDialogComponent,
        { type: "fly_grammar", showTheStarter: false, error: "enableDisableFlyGrammar" },
        "800px"
      );
      return new Observable((subscriber) => subscriber.complete());
    }

    const { flyGrammar, flyGrammarLanguage } = this.form.value;
    this.lastSavedEnabled = flyGrammar;
    this.lastSavedLanguage = flyGrammarLanguage;
    return this.settingsService.saveFlyGrammar(flyGrammar, flyGrammarLanguage);
  }

  resetToLastSaved(): void {
    this.form.patchValue(
      { flyGrammar: this.lastSavedEnabled, flyGrammarLanguage: this.lastSavedLanguage },
      { emitEvent: false }
    );
  }

  get flyGrammarEnabled(): boolean {
    return this.form?.get("flyGrammar")?.value;
  }

  // vng-select is data-driven ([options]) — 04-component-gaps-and-issues.md / R5.
  get languageOptions(): VngSelectOption[] {
    return this.languages.map((language) => ({ value: language.id, label: language.value }));
  }
}
